var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 278,
    height: 284,
    viewBox: "0 0 278 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.96 119.825V105.005C103.96 100.144 100.019 96.2031 95.1581 96.2031H9.13013C4.26913 96.2031 0.328125 100.144 0.328125 105.005V119.825V218.557C0.328125 223.418 4.26913 227.359 9.13013 227.359H146.697C151.558 227.359 155.499 223.418 155.499 218.557V128.627C155.499 123.766 151.558 119.825 146.697 119.825H103.96Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.46 119.825V120.325H103.96H146.697C151.282 120.325 154.999 124.042 154.999 128.627V218.557C154.999 223.142 151.282 226.859 146.697 226.859H9.13013C4.54527 226.859 0.828125 223.142 0.828125 218.557V119.825V105.005C0.828125 100.42 4.54527 96.7031 9.13013 96.7031H95.1581C99.743 96.7031 103.46 100.42 103.46 105.005V119.825Z",
    stroke: "black",
    strokeOpacity: 0.12
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.906 102.053L150.181 97.0947L163.939 99.6167L170.818 92.2787L187.098 96.6357L196.156 84.2537L212.33 94.1677L206.827 59.2047L185.485 44.2617L136.433 51.9817C134.596 52.2707 133.342 53.9937 133.631 55.8307L140.906 102.053Z",
    fill: "#F5F5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M190.469 61.7787L206.826 59.2047L185.484 44.2617L187.953 59.9467C188.141 61.1477 189.268 61.9677 190.469 61.7787Z",
    fill: "#D6D6D6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M185.484 44.2617L187.953 59.9467C188.142 61.1477 189.269 61.9677 190.47 61.7787L206.827 59.2047",
    stroke: "#262626",
    strokeWidth: 0.274,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M147.518 147.96C147.807 149.797 149.53 151.051 151.367 150.762L215.624 140.649C217.461 140.36 218.715 138.637 218.426 136.8L212.33 98.0663L196.156 88.1523L187.098 100.534L170.818 96.1773L163.939 103.515L150.181 100.993L140.906 105.951L147.518 147.96Z",
    fill: "#F5F5F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M140.92 102.053L150.195 97.0947L163.953 99.6167L170.832 92.2787L187.112 96.6357L196.17 84.2537L212.344 94.1677L206.841 59.2047L185.499 44.2617L136.447 51.9817C134.61 52.2707 133.356 53.9937 133.645 55.8307L140.92 102.053Z",
    stroke: "#262626",
    strokeWidth: 0.274,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M147.532 147.96C147.821 149.797 149.544 151.051 151.381 150.762L215.638 140.649C217.475 140.36 218.729 138.637 218.44 136.8L212.344 98.0663L196.17 88.1523L187.112 100.534L170.832 96.1773L163.953 103.515L150.195 100.993L140.92 105.951L147.532 147.96Z",
    stroke: "#262626",
    strokeWidth: 0.274,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M119.176 265.268C114.326 260.501 114.258 252.705 119.025 247.855L175.718 190.168L193.282 207.43L136.589 265.116C131.822 269.967 124.026 270.035 119.176 265.268Z",
    fill: "#16A34A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M220.335 212.243C247.834 212.18 270.074 189.837 270.011 162.338C269.948 134.84 247.605 112.6 220.106 112.663C192.608 112.726 170.368 135.069 170.431 162.567C170.494 190.066 192.837 212.306 220.335 212.243Z",
    fill: "#DCF0FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M173.613 180.013C175.292 184.48 177.632 188.752 180.637 192.677L269.987 161.772C269.92 156.941 269.151 152.121 267.688 147.473L173.613 180.013Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M170.537 165.755C170.723 168.58 171.15 171.39 171.816 174.155L265.489 141.755C264.321 139.2 262.93 136.725 261.308 134.359L170.537 165.755Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M260.486 121.483C237.852 99.2381 201.47 99.5541 179.225 122.189C156.98 144.823 157.296 181.205 179.931 203.45C202.565 225.695 238.947 225.379 261.192 202.744C283.437 180.109 283.121 143.727 260.486 121.483ZM187.039 196.217C168.399 177.898 168.139 147.937 186.458 129.296C204.777 110.656 234.738 110.396 253.378 128.715C272.018 147.034 272.278 176.995 253.959 195.636C235.641 214.276 205.679 214.536 187.039 196.217Z",
    fill: "#16A34A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M179.699 212.738L134.871 258.351",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M224.329 109.135C210.205 107.71 195.562 112.585 185.11 122.191C174.658 131.798 168.569 145.979 168.801 160.173",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchFile);
export default __webpack_public_path__ + "static/media/searchFile.00fccfdcfead803a7ab476a4b0caa940.svg";
export { ForwardRef as ReactComponent };